const CurrenciesSelect = () => {
  const currenciesSelects = Array.from(document.querySelectorAll(".custom-select-currencies"));

  if (currenciesSelects.length > 0) {
    currenciesSelects.forEach((select) => {
      select.addEventListener("click", (event) => {
        event.stopPropagation();
      });
      const opener = select.querySelector(".select-opener");
      const optionsContainer = select.querySelector(".select-options");
      const placeholderImage = select.querySelector(".select-placeholder-image");

      if (opener) {
        opener.addEventListener("click", () => {
          select.classList.toggle("active");
        });
      }

      if (optionsContainer) {
        optionsContainer.addEventListener("click", (event) => {
          event.preventDefault();
          const option = event.target.closest(".select-option");
          if (option) {
            const imgSrc = option.querySelector('img').src;
            const imgAlt = option.querySelector('img').alt;
            placeholderImage.src = imgSrc;
            placeholderImage.alt = imgAlt;
            select.classList.remove("active");
          }
        });
      }
    });

    document.addEventListener("click", (event) => {
      const activeSelects = currenciesSelects.filter((select) =>
        select.classList.contains("active")
      );
      if (activeSelects.length > 0) {
        activeSelects.forEach((select) => select.classList.remove("active"));
      }
    });
  }
};

export default CurrenciesSelect;


// function changeCurrency() {
//     let currencies = [...document.querySelectorAll('.custom-select-currencies .select-option')];
    
//   if (currencies.length > 0) {
//     currencies.forEach((currency) => {
//       currency.addEventListener("click", (event) => {
//         console.log("currency.value", currency.value);
//       });
//     });    
//   };
// };